<script setup lang="ts">
import PgConfirmDialog from "~/components/Common/PgConfirmDialog.vue";
import { useCommonStore } from "~/stores/common/store";
import { version } from "./package.json";
import { consola } from "consola";

const route = useRoute();
const config = useRuntimeConfig();

useHead({
  script: [
    {
      src: "//cdn.trackdesk.com/tracking.js",
      async: true,
    },
    {
      innerHTML: `
        (function(t,d,k){(t[k]=t[k]||[]).push(d);t[d]=t[d]||t[k].f||function(){(t[d].q=t[d].q||[]).push(arguments)}})(window,"trackdesk","TrackdeskObject");
        trackdesk("pokergo", "click");
      `,
    },
  ],
});

useSeoMeta({
  title: "PokerGO",
  description:
    "Stream the world’s largest collection of live poker tournaments and TV shows like the World Series of Poker (WSOP), Poker After Dark, High Stakes Poker, and more on PokerGO.",

  ogTitle: "PokerGO",
  ogDescription:
    "Stream the world’s largest collection of live poker tournaments and TV shows like the World Series of Poker (WSOP), Poker After Dark, High Stakes Poker, and more on PokerGO.",
  ogSiteName: "PokerGO",
  ogUrl: () => `${config.public.siteUrl}${route.fullPath}`,
  ogImage: () => `${config.public.siteUrl}/og-image.png`,

  googleSiteVerification: "83seNIc0yB1_pTXXDaexhtoqHz3jD-IxjcnGV7KTc_U",

  twitterSite: "@PokerGO",
  twitterCreator: "@PokerGO",
  twitterTitle: "PokerGO",
  twitterDescription:
    "Stream the world’s largest collection of live poker tournaments and TV shows like the World Series of Poker (WSOP), Poker After Dark, High Stakes Poker, and more on PokerGO.",
  twitterImage: () => `${config.public.siteUrl}/og-image.png`,
});

const commonStore = useCommonStore();

onMounted(() => {
  consola.info(`PokerGO: v${version}`);
  commonStore.fetchAndSetBanners();
});
</script>

<template>
  <NuxtLayout>
    <Toast />
    <PgConfirmDialog />
    <DynamicDialog />
    <NuxtPage />
  </NuxtLayout>
</template>
